import { ArticleConstuctorBlocks, ArticleImage, ArticleProducts, ArticleVideo, ArticleWysiwyg } from '@/api/article';
import { ApiArticleTag } from '@/api/tags';
import Card from '@/components/shared/Card';
import YoutubeVideo from '@/components/shared/YoutubeVideo';
import { Product } from '@/types';
import { withLeadingZero } from '@/utils/strings';
import Image from 'next/image';
import ArticleProductsList from '../ArticleProducts/ArticleProducts';
import Link from '@/components/shared/Link';
import WebShare from '@/components/shared/WebShare';
import { useRouter } from 'next/router';
import ConstructorVideoPlayer from '@/components/shared/ConstructorVideoPlayer';

type Props = {
    signature: string;
    tags: ApiArticleTag[];
    published_at: number;
    constructor: ArticleConstuctorBlocks;
    products: Product[];
    title: string;
};

const ArticleBody = ({ signature, tags, published_at, constructor, products, title }: Props) => {
    const date = new Date(published_at * 1000);
    const formatedDate = `${withLeadingZero(date.getDate())}.${withLeadingZero(date.getMonth() + 1)}.${date.getFullYear()}`;

    return (
        <div className="article-body">
            <div className="article-body__top article-wrapper">
                <div className="article-body__left">
                    <div className="article-left__info m-text-xs">
                        {signature} <span className="article-left__info--opacity">/ {formatedDate}</span>
                    </div>

                    {tags && tags.length > 0 && (
                        <ul className="article-tags-list list-unstyled">
                            {tags.map((item) => {
                                return (
                                    <li key={item.id} className="article-tag m-text-xs">
                                        <Link href={`/blog?tags[]=${item.id}`}>{`[ ${item.name} ]`}</Link>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
                <div className="article-body__right">
                    <WebShare
                        title={title}
                        telegram
                        vk
                        whatsapp
                        url={typeof window !== 'undefined' ? window.location.href : ''}
                    />
                </div>
            </div>
            <div className="article-constructor">
                {constructor.map((item, i) => {
                    switch (item.name) {
                        case 'wysiwyg':
                            const wysiwygItem = item as ArticleWysiwyg;
                            return (
                                wysiwygItem.properties.text && (
                                    <div className="wrapper" key={i}>
                                        <div className="constructor-block article-wrapper article-wysiwyg">
                                            <div dangerouslySetInnerHTML={{ __html: wysiwygItem.properties.text }} />
                                        </div>
                                    </div>
                                )
                            );
                        case 'image':
                            const imageItem = item as ArticleImage;
                            return (
                                imageItem.properties.image && (
                                    <div className="wrapper" key={i}>
                                        <div className="constructor-block constructor-block--media">
                                            <Image
                                                src={imageItem.properties.image.src}
                                                width={imageItem.properties.image.width}
                                                height={imageItem.properties.image.height}
                                                alt={imageItem.properties.image.alt ?? ''}
                                            />
                                        </div>
                                    </div>
                                )
                            );
                        case 'video':
                            const videoItem = item as ArticleVideo;
                            return videoItem.properties.youtube ? (
                                <div className="wrapper" key={i}>
                                    <div className="constructor-block constructor-block--media">
                                        <YoutubeVideo id={videoItem.properties.youtube} />
                                    </div>
                                </div>
                            ) : (
                                videoItem.properties.video && (
                                    <div className="wrapper" key={i}>
                                        <div className="constructor-block constructor-block--media">
                                            <ConstructorVideoPlayer video={videoItem.properties.video} />
                                        </div>
                                    </div>
                                )
                            );
                        case 'products':
                            const productsItem = item as ArticleProducts;
                            const productsItemIds: number[] =
                                productsItem.properties.products?.map((product) => Number(product.id)) ?? [];
                            const currentProducts = products.filter((product) => productsItemIds.includes(product.id));

                            return (
                                <div className="constructor-block" key={i}>
                                    <ArticleProductsList products={currentProducts} />
                                </div>
                            );
                    }
                })}
            </div>
        </div>
    );
};

export default ArticleBody;
